import { styled } from '@mui/material/styles';

const PREFIX = 'ButtonException';

const classes = {
  container: `${PREFIX}-container`,
  buttonText: `${PREFIX}-buttonText`,
};

const StyledButtonException = styled('button')(({ theme }) => ({
  [`&.${classes.container}`]: {
    minWidth: '105px',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    borderRadius: '3px',
    background: 'var(--Light-Primary-Main, #197CB3)',
    boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.30)',
    display: 'flex',
    padding: '4px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#145E87',
    },
    '&:disabled': {
      backgroundColor: '#197CB3',
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  [`& .${classes.buttonText}`]: {
    color: 'var(--Light-Primary-Contrast, #FFF)',
    fontFamily: 'Source Sans Pro',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.46px',
  },
}));

type ButtonExceptionProps = {
  label: string;
  onClick: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  'data-fs-element'?: string;
};

const ButtonException = ({
  label,
  onClick,
  disabled,
  'data-fs-element': dataFsElement,
}: ButtonExceptionProps) => {
  return (
    <StyledButtonException
      className={classes.container}
      onClick={onClick}
      disabled={disabled || false}
      data-fs-element={dataFsElement}>
      <span className={classes.buttonText}>{label}</span>
    </StyledButtonException>
  );
};

export { ButtonException };
export type { ButtonExceptionProps };
